import React, { FC } from 'react';
import { Paper } from '@mui/material';
import { useSelector } from 'react-redux';

import { useTranslate } from 'src/shared/providers';
import { RootState } from 'src/store/types';

import { DisplayExperienceForm } from './DisplayExperienceForm';
import { DisplayThemeForm } from './DisplayThemeForm';

export const DisplayPreferencesSection: FC = () => {
  const { t } = useTranslate();
  const { settings } = useSelector((state: RootState) => state.user);

  return (
    <Paper id="preferences-card" className="h-100 p-4">
      <div className="mb-3">
        <h4 className="pb-0 mb-0">{t('settings.displayPreferences')}</h4>
        <label className="text-muted d-block">{t('settings.youWillBeAbleToChangeYourDisplayPreferencesHere')}</label>
      </div>
      <div>
        <DisplayThemeForm />
        {settings?.backToClassicLinkEnabled && <DisplayExperienceForm />}
      </div>
    </Paper>
  );
};
